const abroadCodes: string[][] = [
    ["Z106", "VAT"],
    ["Z107", "DNK"],
    ["Z108", "FRO"],
    ["Z109", "FIN"],
    ["Z110", "FRA"],
    ["Z112", "DEU"],
    ["Z113", "GIB"],
    ["Z114", "GBR"],
    ["Z115", "GRC"],
    ["Z116", "IRL"],
    ["Z117", "ISL"],
    ["Z119", "LIE"],
    ["Z120", "LUX"],
    ["Z121", "MLT"],
    ["Z122", "IMN"],
    ["Z123", "MCO"],
    ["Z124", "CHA"],
    ["Z125", "NOR"],
    ["Z126", "NLD"],
    ["Z127", "POL"],
    ["Z128", "PRT"],
    ["Z129", "ROU"],
    ["Z130", "SMR"],
    ["Z131", "ESP"],
    ["Z132", "SWE"],
    ["Z133", "CHE"],
    ["Z134", "HUN"],
    ["Z138", "UKR"],
    ["Z139", "BLR"],
    ["Z140", "MDA"],
    ["Z144", "EST"],
    ["Z145", "LVA"],
    ["Z146", "LTU"],
    ["Z148", "MKD"],
    ["Z149", "HRV"],
    ["Z150", "SVN"],
    ["Z153", "BIH"],
    ["Z154", "RUS"],
    ["Z155", "SVK"],
    ["Z156", "CZE"],
    ["Z160", "XXK"],
    ["Z161", "PSE"],
    ["Z200", "AFG"],
    ["Z203", "SAU"],
    ["Z204", "BHR"],
    ["Z205", "BTN"],
    ["Z206", "MMR"],
    ["Z207", "BRN"],
    ["Z208", "KHM"],
    ["Z209", "LKA"],
    ["Z210", "CHN"],
    ["Z211", "CYP"],
    ["Z212", "CCK"],
    ["Z213", "KOR"],
    ["Z214", "PRK"],
    ["Z215", "ARE"],
    ["Z216", "PHL"],
    ["Z217", "TWN"],
    ["Z218", "GZA"],
    ["Z219", "JPN"],
    ["Z220", "JOR"],
    ["Z222", "IND"],
    ["Z223", "IDN"],
    ["Z224", "IRN"],
    ["Z225", "IRQ"],
    ["Z226", "ISR"],
    ["Z227", "KWT"],
    ["Z228", "LAO"],
    ["Z229", "LBN"],
    ["Z231", "MAC"],
    ["Z232", "MDV"],
    ["Z233", "MNG"],
    ["Z234", "NPL"],
    ["Z235", "OMN"],
    ["Z236", "PAK"],
    ["Z237", "QAT"],
    ["Z240", "SYR"],
    ["Z241", "THA"],
    ["Z243", "TUR"],
    ["Z246", "YEM"],
    ["Z247", "MYS"],
    ["Z248", "SGP"],
    ["Z249", "BGD"],
    ["Z251", "VNM"],
    ["Z252", "ARM"],
    ["Z253", "AZE"],
    ["Z254", "GEO"],
    ["Z255", "KAZ"],
    ["Z256", "KGZ"],
    ["Z257", "TJK"],
    ["Z258", "TKM"],
    ["Z259", "UZB"],
    ["Z300", "NAM"],
    ["Z301", "DZA"],
    ["Z302", "AGO"],
    ["Z305", "BDI"],
    ["Z306", "CMR"],
    ["Z307", "CPV"],
    ["Z308", "CAF"],
    ["Z309", "TCD"],
    ["Z310", "COM"],
    ["Z311", "COG"],
    ["Z312", "COD"],
    ["Z313", "CIV"],
    ["Z314", "BEN"],
    ["Z315", "ETH"],
    ["Z316", "GAB"],
    ["Z317", "GMB"],
    ["Z318", "GHA"],
    ["Z319", "GIN"],
    ["Z320", "GNB"],
    ["Z321", "GNQ"],
    ["Z322", "KEN"],
    ["Z324", "REU"],
    ["Z325", "LBR"],
    ["Z326", "LBY"],
    ["Z327", "MDG"],
    ["Z328", "MWI"],
    ["Z329", "MLI"],
    ["Z330", "MAR"],
    ["Z331", "MRT"],
    ["Z332", "MUS"],
    ["Z333", "MOZ"],
    ["Z334", "NER"],
    ["Z335", "NGA"],
    ["Z336", "EGY"],
    ["Z337", "ZWE"],
    ["Z338", "RWA"],
    ["Z340", "SHN"],
    ["Z341", "STP"],
    ["Z342", "SYC"],
    ["Z343", "SEN"],
    ["Z344", "SLE"],
    ["Z345", "SOM"],
    ["Z347", "SGS"],
    ["Z348", "SDN"],
    ["Z349", "SWZ"],
    ["Z351", "TGO"],
    ["Z352", "TUN"],
    ["Z353", "UGA"],
    ["Z354", "BFA"],
    ["Z355", "ZMB"],
    ["Z357", "TZA"],
    ["Z358", "BWA"],
    ["Z359", "LSO"],
    ["Z360", "MYT"],
    ["Z361", "DJI"],
    ["Z368", "ERI"],
    ["Z516", "PAN"],
    ["Z400", "BMU"],
    ["Z401", "CAN"],
    ["Z402", "GRL"],
    ["Z403", "SPM"],
    ["Z404", "USA"],
    ["Z501", "ANT"],
    ["Z502", "BHS"],
    ["Z503", "CRI"],
    ["Z504", "CUB"],
    ["Z505", "DOM"],
    ["Z506", "SLV"],
    ["Z507", "JAM"],
    ["Z508", "GLP"],
    ["Z509", "GTM"],
    ["Z510", "HTI"],
    ["Z511", "HND"],
    ["Z512", "BLZ"],
    ["Z513", "MTQ"],
    ["Z514", "MEX"],
    ["Z515", "NIC"],
    ["Z517", "PCZ"],
    ["Z518", "PRI"],
    ["Z519", "TCA"],
    ["Z520", "VIR"],
    ["Z522", "BRB"],
    ["Z524", "GRD"],
    ["Z525", "VGB"],
    ["Z526", "DMA"],
    ["Z527", "LCA"],
    ["Z528", "VCT"],
    ["Z529", "AIA"],
    ["Z530", "CYM"],
    ["Z531", "MSR"],
    ["Z532", "ATG"],
    ["Z533", "KNA"],
    ["Z600", "ARG"],
    ["Z601", "BOL"],
    ["Z602", "BRA"],
    ["Z603", "CHL"],
    ["Z604", "COL"],
    ["Z605", "ECU"],
    ["Z606", "GUY"],
    ["Z607", "GUF"],
    ["Z608", "SUR"],
    ["Z609", "FLK"],
    ["Z610", "PRY"],
    ["Z611", "PER"],
    ["Z612", "TTO"],
    ["Z613", "URY"],
    ["Z614", "VEN"],
    ["Z700", "AUS"],
    ["Z702", "CXR"],
    ["Z703", "COK"],
    ["Z704", "FJI"],
    ["Z706", "GUM"],
    ["Z707", "PB"],
    ["Z708", "AU"],
    ["Z710", "MNP"],
    ["Z711", "MHL"],
    ["Z712", "MID"],
    ["Z713", "NRU"],
    ["Z714", "NIU"],
    ["Z715", "NFK"],
    ["Z716", "NCL"],
    ["Z719", "NZL"],
    ["Z721", "UTC"],
    ["Z722", "PCN"],
    ["Z723", "PYF"],
    ["Z724", "SLB"],
    ["Z725", "ASM"],
    ["Z726", "WSM"],
    ["Z727", "TKL"],
    ["Z728", "TON"],
    ["Z729", "WLF"],
    ["Z730", "PNG"],
    ["Z731", "KIR"],
    ["Z732", "TUV"],
    ["Z733", "VUT"],
    ["Z734", "PLW"],
    ["Z735", "FSM"],
    ["Z800", "CA"],
    ["Z801", "NOK"],
    ["Z802", "RU"],
    ["Z900", "ATA"],
    ["Z901", "GB"],
    ["Z902", "FR"],
    ["Z903", "NZ"],
    ["Z904", "NO"],
    ["Z905", "US"],
    ["Z906", "ZAF"],
    ["Z907", "SSD"],
    ["Z100", "ALB"],
    ["Z101", "AND"],
    ["Z102", "AUT"],
    ["Z103", "BEL"],
    ["Z104", "BGR"]
];

export function resolveAboradCode(code: string): string {
    const match = abroadCodes.find(t => t[0] == code);
    return match ? match[1] : null;
}
